<template>
    <div class="form-group">
        <label class="form-label small mb-1">
            <localized-text localizedKey="Contenuto" text="Contenuto"></localized-text>
        </label>
        <input class="form-control" type="text" v-model="localValue.text" />
    </div>
</template>

<script lang="ts">
import * as OM from '@/model';
import { Options } from 'vue-class-component';
import { Mixins, Watch } from 'vue-property-decorator';
import WithModel from '@/mixins/withModel';

@Options({})
export default class titleBlock extends Mixins(WithModel) {
    declare localValue: OM.TitleBlock;

    created(){
        if(!this.localValue.text){
            this.localValue.text = "";
        }
    }
    
    @Watch('localValue.isFullWidth')
    @Watch('localValue.marginBottom')
    @Watch('localValue.text')
    onTextChange(){
        this.localValue.htmlText = `
            <div class="titleBlock title text-center ${(!this.localValue.isFullWidth ? 'px-4' : '')} ${('mb-' + this.localValue.marginBottom)}">
                ${this.localValue.text}
            </div>
        `;
    }

}
</script>
